<template>
  <div>

    <div class="btn-group-justify-end">
      <button @click="$router.push('internal_plugin/create')"
              class="button is-primary">플러그인 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="600"
                 @check="clickCheckBox"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="use_type" slot-scope="props">{{ useTypeText(props.item.use_type) }}</div>
      <div slot="modify_delete" slot-scope="props">
        <template v-if="showModify">
          <button class="button half"
                  @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
          <button class="button half is-danger"
                  @click.stop.prevent="clickItem(props.item,'delete')">삭제</button>
        </template>
        <template v-else>-</template>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: "InternalPluginList",
    mixins: [
      ListMixin
    ],
    created () {
      this.init();
    },
    computed: {
      showModify() {
        let username = this.$store.getters.admin.username;
        let list = ['launchpack', 'juno', 'namo'];
        return list.indexOf(username)>-1
      }
    },
    methods: {
      init() {
        this.initializing('launchpack_internal_plugin', 'launchpack/internal_plugin');
      },
      getDataFromServer() {
        this.getData();
      },
      clickItem(item, kind) {
        if (kind === "update") {
          this.$router.push(this.getPath("launchpack/internal_plugin/create?id=" +item.id));
        } else if (kind === "delete") {
          let value = {
            id: item.id,
            url: 'launchpack/internal_plugin/',
            title: `${item.name}을 삭제하시겠습니까?`
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      useTypeText(item) {
        return {
          0: '프론트+백오피스',
          1: '백오피스',
          2: '백오피스 패널'
        }[item];
      }
    }
  }
</script>

<style scoped>

</style>
